angular.module('iw.frontyard.signup')
    .constant('SignupEmailValidityRegExp', /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/);